import React, { useState } from 'react';
import styles from './Footer.module.scss';
import cx from 'classnames';
import { Countdown } from 'src/components/Countdown/Countdown';

import { ExtensionHandler } from 'src/utils/extension.utils';
import { getRoundOfTimeInSeconds } from 'src/utils/commonUtils';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import debounce from '@utils/Debounce';
import { HrcDisconnectTextConstants } from '../dc97Constant';

interface FooterProps {
  isCallEnded: boolean;
  disConnectHandler: () => void;
}

export const Footer = (props: FooterProps) => {
  const { isCallEnded, disConnectHandler } = props;
  const isAmeyoErroneous = useSelector((state: RootState) => state.humanReminder?.isAmeyoErronous);
  const humanReminderCustomerDetails = useSelector(
    (state: RootState) => state.common?.humanReminderCustomerDetails
  );
  const disconnectApiLoading = useSelector(
    (state: RootState) => state.humanReminder?.disconnectApiLoading
  );
  const [callDuration, setCallDuration] = useState(0);
  const onDisableClick = () => {
    if (isCallEnded || disconnectApiLoading) {
      ExtensionHandler.getCurrentCallStatus();
      return;
    }
    disConnectHandler();
  };
  const handleCallDuration = (value: number) => {
    setCallDuration(value);
  };

  const startFrom = (ExtensionHandler.currentCallStatus().acceptedAt || Date.now()) / 1000;

  return (
    <div className={styles.footer}>
      <div className={styles.footerItemsContainer}>
        <div className={styles.callDuraction}>
          <span className={styles.callDuractionText}>
            {isCallEnded ? 'Call Duration' : 'Ongoing Call'}
          </span>
          <span
            className={
              isCallEnded || isAmeyoErroneous ? styles.callDuractionTime : styles.ongoingCallTime
            }
          >
            {isCallEnded ? (
              <>
                {getRoundOfTimeInSeconds(
                  (ExtensionHandler.currentCallStatus().disconnectedAt -
                    ExtensionHandler.currentCallStatus().acceptedAt) /
                    1000
                )}
                {' seconds'}
              </>
            ) : (
              <Countdown
                startFrom={Date.now() / 1e3 - startFrom}
                step={handleCallDuration}
                isReverseCounter
                stepCalculator={() => Date.now() / 1e3 - startFrom}
                formatter={isCallEnded || isAmeyoErroneous ? 'ss seconds' : 'MM:SS'}
                stopCountdown={isCallEnded || isAmeyoErroneous}
              />
            )}
          </span>
        </div>
        <div
          className={cx(
            styles.disConnectButton,
            isCallEnded || isAmeyoErroneous || disconnectApiLoading
              ? styles.disConnectButtonOpacity
              : ''
          )}
          onClick={() => debounce(onDisableClick)()}
        >
          {disconnectApiLoading ? (
            <span className={styles.disConnectText}>
              {HrcDisconnectTextConstants.DISCONNECTING}
            </span>
          ) : (
            <span className={styles.disConnectText}>
              {isCallEnded
                ? HrcDisconnectTextConstants.DISCONNECTED
                : HrcDisconnectTextConstants.DISCONNECT}
            </span>
          )}
        </div>
        <div className={styles.sourceContainer}>
          <span className={styles.sourceText}>Source:</span>{' '}
          <span className={styles.sourceValue}>
            {humanReminderCustomerDetails?.humanReminderResponse?.source}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
